var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comp-4-modify-goals',{attrs:{"section":20,"page":2}},[_vm._v("\n    Remember your goal from the first session? Here’s what you said you wanted to accomplish:\n")])}
var staticRenderFns = []

export { render, staticRenderFns }